import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { forwardRef } from "react";
import { flexStyles, marginStyles, positionStyles } from "ui";

export const Root = forwardRef<HTMLDivElement, ComponentProps["SideMenu"]["Root"]>((props, ref) => {
  const { className, children } = props;

  return (
    <div
      className={classNames(flexStyles.horiz050, positionStyles.zIndex147, marginStyles.mie100, className)}
      ref={ref}
    >
      {children}
    </div>
  );
});
